<edu-card class="settings-card">
  <h2 edu-card-title>AI correctors</h2>
  <p class="desc">
    Choose the AI provider behind each corrector. Correctors left on Default
    keep the provider they run on today.
  </p>

  <span class="hint" *ngIf="!canManage">You do not have permission to change these settings.</span>

  <div class="corrector-row" *ngFor="let c of correctors">
    <div class="corrector-info">
      <h3 class="corrector-name">{{ c.name }}</h3>
      <p class="corrector-sub">{{ c.description }}</p>
    </div>

    <p class="fixed-note" *ngIf="c.fixed">
      {{ providerLabel(c.providers[0]) }} only — this corrector depends on
      features no other provider has.
    </p>

    <div class="provider-chips" *ngIf="!c.fixed">
      <button
        type="button"
        class="chip"
        [class.selected]="selectionFor(c.kind) === useDefault"
        [disabled]="!canManage || isSaving()"
        (click)="select(c.kind, useDefault)"
      >
        {{ defaultLabel }}
      </button>

      <button
        type="button"
        class="chip"
        *ngFor="let p of c.providers"
        [class.selected]="selectionFor(c.kind) === p"
        [disabled]="!canManage || isSaving()"
        (click)="select(c.kind, p)"
      >
        {{ providerLabel(p) }}
      </button>
    </div>
  </div>

  <div class="footer" *ngIf="canManage">
    <button class="link-button" (click)="save()" [disabled]="isSaving()">
      {{ isSaving() ? 'Saving...' : 'Save changes' }}
    </button>
  </div>
</edu-card>
